function Content({ children, bgColor = 'bg-white' }) {
  return (
    <div className={`${bgColor} py-48`}>
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-12 gap-8">
        {children}
      </div>
    </div>
  );
}

export default Content;